import * as rd from '@devexperts/remote-data-ts'
import { createSelector } from '@reduxjs/toolkit'
import { cartSlice } from '..'

export const reservationPricesSelector = createSelector(
  [cartSlice.selectors.lastSuccessfulQuote, cartSlice.selectors.quote],
  (lastSuccessfulQuote, quote) => {
    // if the quote API call is not finished, we use the lastSuccesfulQuote result
    // to prevent layout shifts in those component where we display reservation prices

    const quoteData = lastSuccessfulQuote
      ? rd.getOrElse(() => lastSuccessfulQuote)(quote)
      : null

    if (!quoteData) return {}

    if (Array.isArray(quoteData.reservationPrices)) {
      // eslint-disable-next-line no-console
      console.warn(
        'quoteData.reservationPrices is an array, returning an empty object'
      )
      return {}
    }

    const reservationPrices = { ...quoteData.reservationPrices }
    const reservationOffers = quoteData.offer

    if (!reservationOffers) return reservationPrices

    Object.keys(reservationOffers).forEach((key) => {
      const offer = reservationOffers[key]
      reservationPrices[key] =
        offer.value < 0
          ? reservationPrices[key] + Math.abs(offer.value)
          : reservationPrices[key]
    })

    return reservationPrices
  }
)
